// All this does is provide a way to import v3/common via javascript_packs_with_chunks_tag
// move import of v3/common back into v3 apps once they are all webpacked and delete this file
import '../../assets/javascripts/v3/modules/common.js';
